import { StandardProposalItemPreviewEntity } from "./StandardProposalItemPreviewEntity";

export interface StdProposalCopyToProposalEntity {

    companyCode: string,
    proposalNo: string,
    copyToNewTariff: StandardProposalItemPreviewEntity[],
}

export const EMPTY_STD_PROPOSAL_COPY_TO_PROPOSAL_ENTITY: StdProposalCopyToProposalEntity = {
    companyCode: "",
    proposalNo: "",
    copyToNewTariff: []
}